import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  packingList: 'PackingList',
  packingListMeta: 'PackingListMeta',
  finishedGoods: 'FinishedGoods',
  priceSheets: 'PriceSheets',
  inventoryCommodity: 'InventoryCommodity',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.packingList, TAG_TYPES.packingListMeta],
  endpoints: {
    getPackingLists: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(packingList => ({
                type: TAG_TYPES.packingList,
                id: packingList.id,
              })),
              { type: TAG_TYPES.packingList, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'PackingList', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.packingList, id: 'LIST' }],
    },
    getPackingListById: {
      providesTags: (result, error, { packingListId }) => [{ type: TAG_TYPES.packingList, packingListId }],
    },
    createPackingList: {
      invalidatesTags: [
        { type: TAG_TYPES.packingList, id: 'LIST' },
        { type: TAG_TYPES.finishedGoods },
        { type: TAG_TYPES.priceSheets },
        { type: TAG_TYPES.inventoryCommodity },
        { type: TAG_TYPES.packingListMeta },
      ],
    },
    updatePackingList: {
      invalidatesTags: [
        { type: TAG_TYPES.packingList, id: 'LIST' },
        { type: TAG_TYPES.finishedGoods },
        { type: TAG_TYPES.priceSheets },
        { type: TAG_TYPES.inventoryCommodity },
        { type: TAG_TYPES.packingListMeta },
      ],
    },
    voidPackingList: {
      invalidatesTags: [
        { type: TAG_TYPES.packingList, id: 'LIST' },
        { type: TAG_TYPES.finishedGoods },
        { type: TAG_TYPES.priceSheets },
        { type: TAG_TYPES.inventoryCommodity },
        { type: TAG_TYPES.packingListMeta },
      ],
    },
    getInventoryPackingListMeta: {
      providesTags: result =>
        result && result.Items
          ? // successful query
            [
              ...result.Items.map(metaData => ({
                type: TAG_TYPES.packingListMeta,
                id: metaData.id,
              })),
              { type: TAG_TYPES.packingListMeta, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'PackingList', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.packingListMeta, id: 'LIST' }],
    },
  },
})

export const {
  useGetPackingListsQuery,
  useGetPackingListByIdQuery,
  useCreatePackingListMutation,
  useUpdatePackingListMutation,
  useVoidPackingListMutation,
  useGetInventoryPackingListMetaQuery,
} = api
